<template>
  <v-ons-page
    class="content-map"
    modifier="bg-transparent"
    @show="show"
    @hide="hide"
  >
    <div class="background">
      <img src="~@/assets/images/t_workstyle_concierge.png">
    </div>
    <div class="content">
      <transition name="fade">
        <img
          v-if="currentContent === 1"
          key="image-1"
          class="fade-contents"
          src="~@/assets/images/t_workstyle_concierge-1.png"
        >
        <img
          v-if="currentContent === 2"
          key="image-2"
          class="fade-contents"
          src="~@/assets/images/t_workstyle_concierge-2.png"
        >
        <img
          v-if="currentContent === 3"
          key="image-3"
          class="fade-contents"
          src="~@/assets/images/t_workstyle_concierge-3.png"
        >
        <img
          v-if="currentContent === 4"
          key="image-4"
          class="fade-contents"
          src="~@/assets/images/t_workstyle_concierge-4.png"
        >
      </transition>
      <div
        class="link"
        @click="goToMap"
      >体験してみる</div>
    </div>
  </v-ons-page>
</template>

<script>
import mapSplitter from '@/components/map/splitter.vue';

export default {
  data() {
    return {
      currentContent: 1,
      currentContentTimer: null,
    };
  },
  async mounted() {
    await this.goToMap();
  },
  methods: {
    show() {
      this.startAutoContent();
    },
    hide() {
      this.stopAutoContent();
    },
    startAutoContent() {
      this.currentContentTimer = setInterval(() => {
        if (this.currentContent === 4) {
          this.currentContent = 1;
        } else {
          this.currentContent += 1;
        }
      }, 5000);
    },
    stopAutoContent() {
      clearInterval(this.currentContentTimer);
    },
    hideMenu() {
      this.$store.commit('topNavigator/toggleMenu', false);
    },
    async goToMap() {
      try {
        const signInParams = {
          email: process.env.VUE_APP_DEFAULT_SIGNIN_EMAIL,
          password: process.env.VUE_APP_DEFAULT_SIGNIN_PASSWORD,
        };
        await this.$store.dispatch('user/sessions/signIn', signInParams);
        this.initializeLoading();
      } catch (error) {
        this.showErrorAlert('ログインに失敗しました', error);
      }
    },
    async initializeLoading() {
      try {
        await this.getPlaces();
        await this.getPlaceBuildings();
        this.$store.commit('appNavigator/push', mapSplitter);
        this.stopAutoContent();
      } catch (error) {
        this.showErrorAlert('ログインに失敗しました', error);
      }
    },
    getPlaces() {
      return this.$store.dispatch('area/getPlaces');
    },
    getPlaceBuildings() {
      return this.$store.dispatch('area/getPlaceBuildings', 1);
    },
    showErrorAlert(message, error) {
      let alertMessage = '';
      if (error.message.indexOf('Network Error') >= 0) {
        alertMessage = 'インターネットに接続されていません';
      } else {
        alertMessage = message;
      }
      console.log(error);
      this.$ons.notification.alert(alertMessage,
        {
          class: 'login-alert',
          title: false,
          cancelable: true ,
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  overflow: hidden;
}
.content-map {
  .link {
    position: absolute;
    top: 517px;
    left: 170px;
    width: 290px;
    height: 73px;
    opacity: 0;
  }
}
.fade-contents {
  position: absolute;
  left: 715px;
  top: 194px;
  width: 215px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// t_workstyle_concierge.vue?b0692fcc